<mat-card>
  <mat-card-subtitle>
    <form [formGroup]="filterForm">
      <mat-checkbox formControlName="important">
        <mat-icon class="small-icon">whatshot</mat-icon>
        Objekt
      </mat-checkbox>
      <mat-checkbox formControlName="todo">
        <mat-icon class="small-icon">info</mat-icon>
        zu Erledigen
      </mat-checkbox>
    </form>

  </mat-card-subtitle>
  <mat-card-content>
    <button mat-fab class="pull-right" (click)="createReport()">
      <mat-icon class="md-24">add</mat-icon>
    </button>
    <app-data-table [class]="'table table-striped'" [model]="model" [filters]="filters"
                    (rowClick)="router.navigate(['report', $event.id])">
      <colgroup>
        <col class="col-md-2">
        <col class="col-md-2">
        <col class="col-md-2">
        <col class="col-md-5">
        <col class="col-md-1">
      </colgroup>
      <table-column label="Datum">
        <ng-template table-column-content #col="content">
          {{ col.record.appointment?.date_time | date }}
        </ng-template>
      </table-column>
      <table-column label="Kunde">
        <ng-template table-column-content>
          <a [routerLink]="['/customer', col.record.appointment.site.customer.id]">{{
            col.record.appointment.site.fullName
            }}
            {{ col.record.appointment.contactPerson != null ? '(' + col.record.appointment.contactPerson.name + ')' :
            ''}}</a>
        </ng-template>
      </table-column>
      <table-column label="Betreff">
        <ng-template table-column-content>
          <mat-icon *ngIf="col.record.important" class="small-icon">whatshot</mat-icon>
          <mat-icon *ngIf="col.record.todo" class="small-icon">info</mat-icon>
          {{ col.record.subject }}
        </ng-template>
      </table-column>
      <table-column label="Beschreibung">
        <ng-template table-column-content>
          {{ col.record.description }}
        </ng-template>
      </table-column>

      <table-column label="Vor ort">
        <ng-template table-column-content>
          <mat-icon>{{col.record.appointment.on_site ? 'business': 'call'}}</mat-icon>
        </ng-template>
      </table-column>

    </app-data-table>

  </mat-card-content>

</mat-card>





// WEBPACK FOOTER //
// /home/markush/Projects/fieldsale-wingman-client/src/app/report/report-list/report-list.component.html